// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/site_membership/v1/site_membership.proto (package fingertip.creator.site_membership.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { SiteRole } from "../../../common/enum/v1/site_role_pb.js";
import { SiteMembership } from "../../../common/type/v1/site_membership_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";
import { UserProfile } from "../../../common/type/v1/user_profile_pb.js";
import { Site } from "../../../common/type/v1/site_pb.js";

/**
 * @generated from message fingertip.creator.site_membership.v1.UpdateSiteMembershipRequest
 */
export const UpdateSiteMembershipRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.UpdateSiteMembershipRequest",
  () => [
    { no: 1, name: "role", kind: "enum", T: proto3.getEnumType(SiteRole) },
    { no: 2, name: "site_membership_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.UpdateSiteMembershipResponse
 */
export const UpdateSiteMembershipResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.UpdateSiteMembershipResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.DeleteSiteMembershipRequest
 */
export const DeleteSiteMembershipRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.DeleteSiteMembershipRequest",
  () => [
    { no: 1, name: "site_membership_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.DeleteSiteMembershipResponse
 */
export const DeleteSiteMembershipResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.DeleteSiteMembershipResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.CreateSiteMembershipRequest
 */
export const CreateSiteMembershipRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.CreateSiteMembershipRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "enum", T: proto3.getEnumType(SiteRole) },
    { no: 3, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.CreateSiteMembershipResponse
 */
export const CreateSiteMembershipResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.CreateSiteMembershipResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.GetSiteMembershipsRequest
 */
export const GetSiteMembershipsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.GetSiteMembershipsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.GetSiteMembershipsResponse
 */
export const GetSiteMembershipsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.GetSiteMembershipsResponse",
  () => [
    { no: 1, name: "memberships", kind: "message", T: SiteMembership, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.SiteMemberProfile
 */
export const SiteMemberProfile = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.SiteMemberProfile",
  () => [
    { no: 1, name: "membership", kind: "message", T: SiteMembership },
    { no: 2, name: "profile", kind: "message", T: UserProfile },
    { no: 3, name: "has_active_nylas_integration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.GetSiteMemberProfileRequest
 */
export const GetSiteMemberProfileRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.GetSiteMemberProfileRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.GetSiteMemberProfileResponse
 */
export const GetSiteMemberProfileResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.GetSiteMemberProfileResponse",
  () => [
    { no: 1, name: "member_profile", kind: "message", T: SiteMemberProfile },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.GetSiteMemberProfilesRequest
 */
export const GetSiteMemberProfilesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.GetSiteMemberProfilesRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.GetSiteMemberProfilesResponse
 */
export const GetSiteMemberProfilesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.GetSiteMemberProfilesResponse",
  () => [
    { no: 1, name: "member_profiles", kind: "message", T: SiteMemberProfile, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.GetSiteMembershipRequest
 */
export const GetSiteMembershipRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.GetSiteMembershipRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.GetSiteMembershipResponse
 */
export const GetSiteMembershipResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.GetSiteMembershipResponse",
  () => [
    { no: 1, name: "membership", kind: "message", T: SiteMembership },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.GetWorkspaceSitesMembershipRequest
 */
export const GetWorkspaceSitesMembershipRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.GetWorkspaceSitesMembershipRequest",
  () => [
    { no: 1, name: "workspace_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.GetWorkspaceSitesMembershipResponse
 */
export const GetWorkspaceSitesMembershipResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.GetWorkspaceSitesMembershipResponse",
  () => [
    { no: 1, name: "site_memberships", kind: "message", T: WorkspaceSiteMembership, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.site_membership.v1.WorkspaceSiteMembership
 */
export const WorkspaceSiteMembership = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_membership.v1.WorkspaceSiteMembership",
  () => [
    { no: 1, name: "site", kind: "message", T: Site },
    { no: 2, name: "membership", kind: "message", T: SiteMembership },
  ],
);

